module.exports = __webpack_public_path__ + "static/media/arrow-up.bf23f93a.png";